import { useEffect, useCallback } from "react";
import { Card, Col, Row, Badge } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { Table, Title } from "components";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { RootState } from "redux/store";
import { getStores } from "redux/slices/Stores";
import { updateDispensePricingField } from "redux/slices/DispensePricing";

export function DispensePricing() {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const stores = useAppSelector((state: RootState) => state.stores);
	const currentStoreGroupId = useAppSelector((state: RootState) => state.global.storeGroupId);
    const user = useAppSelector((state: RootState) => state.logedinUser);

	useEffect(() => {
		dispatch(getStores({ storeGroupIds: [currentStoreGroupId] }));
	}, []);

	function displayLink(name: any, id: any, connected: any) {
		if (connected === false || !user.permissions.dispensePricing.canView) {
			return <>{name}</>;
		} else {
			return <><Link to={`/app/dispense-price/${id}`}>{name}</Link></>;
		}
	}

	const columns = [
		{
			Header: "Store",
			accessor: "name",
			defaultCanSort: true,
			Cell: (row: any) => displayLink(row.value, row.cell.row.original.id, row.cell.row.original.connected),
		},
		{
			Header: "Status",
			accessor: "connected",
			Cell: (row: any) => {
				return (
					<>
						{row.cell.row.original.connected === false && <Badge className="me-1 badge-outline-danger">Offline</Badge>}
						{row.cell.row.original.connected === true && <Badge className="me-1 badge-outline-primary">Online</Badge>}
					</>
				);
			}
		},
	];

	const selectedRows = useCallback((pageIndex:any) => {
		dispatch(updateDispensePricingField({ key: "selectedRows", value: pageIndex }));
	}, []);

	function handleDelete() {
		// let stockIds: any = [];
		// catalogues.selectedRows.forEach((row: any) => {
		// 	// @ts-ignore
		// 	stockIds.push(catalogues.table[parseInt(row)].id);
		// });
		// console.log("stockIds", stockIds);
		// dispatch(deleteCatalogue(stockIds)).then((res) => {
		// 	console.log("res", res);
		// 	dispatch(getCatalogues());
		// });
	}

	return (
		<>
			<Title pageTitle="Special Pricing" />
			<Row>
				<Col xs={12}>
					<Card>
						<Card.Body>
							<Row className="mb-1">
								<div className="page-container">
									<Table
										pageSize={15}
										isSortable={true}
										pagination={true}
										isSearchable={true}
										disableExport={true}
										columns={columns}
										data={stores.table}
										loading={stores.loading}
										errors={stores.error}
										// selectedRows={selectedRows}
										// removeRows={handleDelete}
										reloadTableRows={() => dispatch(getStores({}))}
									// addNewRow={() => navigate("/app/dispense-price/new")}
									/>
								</div>
							</Row>
						</Card.Body>
					</Card>
				</Col>
			</Row>
		</>
	);
}